/**
 * clinics.ts — the admin clinic roster (config-driven).
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: C1.5 (clinician + admin).
 *
 * WHY: the admin console spans multiple clinics but only Weight Loss is live at
 * launch; the rest render "Coming soon" and are not switchable into. This roster
 * is the single source of truth for the switcher and the not-configured guard —
 * a new clinic goes live by flipping `configured` (and, ultimately, from the
 * clinic-service config), with no other code change.
 */

export interface AdminClinic {
  slug: string;
  name: string;
  /** A configured clinic has a working console; others show "Coming soon". */
  configured: boolean;
}

/**
 * Weight Loss is live; the rest are placeholders until their build lands.
 * NAMES are VERBATIM from the CTO's Wave-7B waffle list (2026-07-21) —
 * including "Hair Loss Clinic", which reads like a typo for "Hair Loss"
 * (flagged in the PR note; ship verbatim until the CTO corrects it). The
 * SLUGS are deliberately unchanged (`hairloss` etc.) so every existing
 * `?clinic=` deep link and bookmark still resolves.
 */
export const ADMIN_CLINICS: AdminClinic[] = [
  { slug: 'weightloss', name: 'Weight Loss Clinic', configured: true },
  { slug: 'adhd', name: 'ADHD Clinic', configured: false },
  { slug: 'menshealth', name: "Men's Health Clinic", configured: false },
  { slug: 'womenshealth', name: "Women's Health Clinic", configured: false },
  { slug: 'hairloss', name: 'Hair Loss Clinic', configured: false },
];

/** The clinic the console (and its header switcher) opens to when `?clinic=` is absent. */
export const DEFAULT_CLINIC_SLUG = 'weightloss';

export function findClinic(slug: string): AdminClinic | undefined {
  return ADMIN_CLINICS.find((c) => c.slug === slug);
}
